export const ReportsTypes = [
    { label: "Arrival Bookings", value: "arrivalBookings", airports: ["A"] },
    { label: "Departures Bookings", value: "departuresBookings", airports: ["A"] },
    { label: "Passengers Record", value: "passengersRecord", airports: ["A"] },
    { label: "Arrival Forecast", value: "arrivalForecast", airports: ["A"] },
    { label: "Departures Forecast", value: "departuresForecast", airports: ["A"] },
    { label: "SLA Report", value: "SLAReport", airports: ["A"] },
    { label: "Airline Performance", value: "AirlinePerformanceReport", airports: ["A"] },
    { label: "Pre-Advised And Advanced", value: "preAdvisedAndAdvanced", airports: ["A"] },
    { label: "Reviews", value: "reviews", airports: ["A"] },
    { label: "Tasks", value: "tasks", airports: ["ORK", "DUB", "BFS", "JER", "SNN", "PUJ", "MLA", "EDI"] },
    { label: "Comparison Report", value: "comparison", airports: ["ORK", "DUB", "BFS", "JER", "SNN", "PUJ", "MLA"] },
    { label: "Employee Conversations", value: "employeeConversations", airports: ["A"] },
    { label: "Flights Conversations", value: "flightsConversations", airports: ["A"] },
    { label: "Flight Report", value: "flightReport", airports: ["DUB", "EDI"] },
    { label: "Productivity Report", value: "productivityReport", airports: ["ORK", "DUB", "BFS", "JER", "SNN", "PUJ", "MLA", "EDI"] },
    { label: "App Session Log", value: "AppSessionLog", airports: ["ORK", "DUB", "BFS", "JER", "SNN", "PUJ", "MLA", "EDI"] },
    { label: "Portal Sessions", value: "portalSessions", airports: ["DUB"] },//
    { label: "Employees Breaks Log", value: "breaksReport", airports: ["ORK", "DUB", "BFS", "JER", "SNN", "PUJ", "MLA", "EDI"] },
    { label: "Gate Changes Report", value: "gateChangesReport", airports: ["ORK", "DUB", "BFS", "JER", "SNN", "PUJ", "MLA"] },
    { label: "Vehicle Report", value: "vehicleReport", airports: ["ORK", "DUB", "BFS", "JER", "SNN", "PUJ", "MLA"] },
    { label: "Shifts", value: "shifts", airports: ["DUB", "BFS", "ORK", "PUJ", "EDI", "SNN"] },
    { label: "Third State Flights", value: "thirdStateFlights", airports: ["DUB"] },
    { label: "Device Report", value: "deviceReport", airports: ["DUB"] },//Comment this while no APK is released
    { label: "SunflowerLanyard Report", value: "sunflowerLanyard", airports: ["DUB"] },//Comment this while no APK is released
    { label: "Movement Report", value: "movementReport", airports: ["DUB"] },
];

export const BookingsTypes = [
    { label: "All Bookings", value: "none" },
    { label: "Portal", value: "P" },
    { label: "App", value: "A" },
    { label: "SITA", value: "S" },
    { label: "Connect API", value: "C" },

]

export const tasksType = [
    { label: "Total", value: "all" },
    { label: "Completed", value: "completed" },
    { label: "Assigned", value: "assigned" },


]

export const taskReportTypes = [
    { label: "All Task Types", value: "all" },
    { label: "Arrival", value: "arrival" },
    { label: "Departure", value: "departure" },
    { label: "Boarding", value: "boarding" },
    { label: "Transit", value: "transit" },
    { label: "Alt Pickup", value: "alt pickup" },
    { label: "Ramp", value: "ramp" },
    { label: "Flight Task", value: "flight task" },
    { label: "Self Allocated", value: "self allocated" },
    { label: "Grouped Self Allocated", value: "grouped self allocated" },
    { label: "Transferred", value: "transferred" },
]

export const preAdvisedAndNonPreAdvised = [
    "        ",
    "Pax Type",
    "Bookings",
    "Completed",
    "Percentage"
];

export const reviewsListTitles = [
    "     ",
    "Name",
    "flight Date",
    "flight",
    "Assistance quality",
    "Staff assistance",
    "Waiting Time",
    "Comments",
];


// STA - STANDARD TIME OF ARRIVAL (ARRIVAL ONLY)
// ACT - ACTUAL TIME OF ARRIVAL (DEPARTURE ONLY)
//SCHEDULE TIME OF DEPARTURE
export const taskColumnsTitles = [
    "Passenger Name",
    "Cat",
    "P adv Y/N",
    "FLT NO",
    "Arr/Dep",
    "Orig/DES",
    "STA",
    // "ACT",
    "STD",
    // "ATD"
    "Agent Name",
    "Task Type",
    "Equipment",
    "Alloc Time",
    "At Loc Time",
    "Start Time",
    "Job Fin",
    "Service Duration",
    "Task Notes"
]


export const airlines = [
    { label: "ALL", value: "" },

    { label: "FR", value: "FR" },
    { label: "EI", value: "EI" },
    { label: "TK", value: "TK" },
    { label: "EK", value: "EK" },
    { label: "AF", value: "AF" },
    { label: "BT", value: "BT" },
    { label: "DL", value: "DL" },
    { label: "BA", value: "BA" },
    { label: "AF", value: "AF" },
    { label: "OU", value: "OU" },
    { label: "XQ", value: "XQ" },
    { label: "VY", value: "VY" },
    { label: "AA", value: "AA" },
    { label: "LH", value: "LH" },
    { label: "UA", value: "UA" },
    { label: "EY", value: "EY" },
    { label: "LX", value: "LX" },
    { label: "LS", value: "LS" },
    { label: "EZY", value: "EZY" },
    { label: "SI", value: "SI" },
    { label: "KL", value: "KL" },
    { label: "TUI", value: "TUI" },
    { label: "BY", value: "BY" },
    { label: "TOM", value: "TOM" },
    { label: "UL", value: "UL" },
    { label: "AC", value: "AC" },
    { label: "QR", value: "QR" },
    { label: "H4", value: "H4" },
    { label: "RK", value: "RK" },
    { label: "DY", value: "DY" },
    { label: "IB", value: "IB" },
    { label: "AP", value: "AP" },
    { label: "TP", value: "TP" },
    { label: "WS", value: "WS" },
    { label: "VA", value: "VA" },
    { label: "2S", value: "2S" },
    { label: "3L", value: "3L" },
    { label: "5K", value: "5K" },
    { label: "8H", value: "8H" },
    { label: "CL", value: "CL" },
    { label: "E4", value: "E4" },
    { label: "EA", value: "EA" },
    { label: "FI", value: "FI" },
    { label: "LM", value: "LM" },
    { label: "OG", value: "OG" },
    { label: "OR", value: "OR" },
    { label: "R6", value: "R6" },
    { label: "SR", value: "SR" },
    { label: "T3", value: "T3" },
    { label: "T9", value: "T9" },
    { label: "TB", value: "TB" },
    { label: "TS", value: "TS" },
    { label: "V3", value: "V3" },
    { label: "W4", value: "W4" },
    { label: "W6", value: "W6" },
    { label: "WG", value: "WG" },
    { label: "XC", value: "XC" },
    { label: "YW", value: "YW" },
    { label: "5M", value: "5M" },
    { label: "6Y", value: "6Y" },
    { label: "A3", value: "A3" },
    { label: "A5", value: "A5" },
    { label: "AY", value: "AY" },
    { label: "D0", value: "D0" },
    { label: "E6", value: "E6" },
    { label: "E9", value: "E9" },
    { label: "EE", value: "EE" },
    { label: "EW", value: "EW" },
    { label: "FH", value: "FH" },
    { label: "FX", value: "FX" },
    { label: "HU", value: "HU" },
    { label: "HV", value: "HV" },
    { label: "I2", value: "I2" },
    { label: "JO", value: "J0" },
    { label: "KL", value: "KL" },
    { label: "LW", value: "LW" },
    { label: "NO", value: "NO" },
    { label: "RC", value: "RC" },
    { label: "RR", value: "RR" },
    { label: "SK", value: "SK" },
    { label: "SN", value: "SN" },
    { label: "VS", value: "VS" },
    { label: "WK", value: "WK" },
    { label: "WX", value: "WX" },
    { label: "ZQ", value: "ZQ" },
    { label: "SV", value: "SV" },
    { label: "6B", value: "6B" },
    { label: "ASL", value: "ASL" },
    { label: "5F", value: "5F" },
    { label: "B6", value: "B6" },
    { label: "MH", value: "MH" },
    { label: "TG", value: "TG" },
    { label: "KE", value: "KE" },
    { label: "GA", value: "GA" },
    { label: "NH", value: "NH" },
    { label: "VL", value: "VL" },
    { label: "AM", value: "AM" },
    { label: "AR", value: "AR" },
    { label: "RER", value: "RER" },
    { label: "TX", value: "TX" },
    { label: "Y2", value: "Y2" },
    { label: "UX", value: "UX" },
    { label: "G4", value: "G4" },
    { label: "DM", value: "DM" },
    { label: "XP", value: "XP" },
    { label: "AV", value: "AV" },
    { label: "MX", value: "MX" },
    { label: "DE", value: "DE" },
    { label: "CM", value: "CM" },
    { label: "4Y", value: "4Y" },
    { label: "WK", value: "WK" },
    { label: "F9", value: "F9" },
    { label: "GX", value: "GX" },
    { label: "G3", value: "G3" },
    { label: "JA", value: "JA" },
    { label: "LA", value: "LA" },
    { label: "LP", value: "LP" },
    { label: "H2", value: "H2" },
    { label: "DO", value: "DO" },
    { label: "WN", value: "WN" },
    { label: "NK", value: "NK" },
    { label: "SY", value: "SY" },
    { label: "SRD", value: "SRD" },
    { label: "P5", value: "P5" },
    { label: "WL", value: "WL" },
    { label: "2W", value: "2W" },
    { label: "3P", value: "3P" },
    { label: "MS", value: "MS" },
    { label: "DN", value: "DN" },
    { label: "F8", value: "F8" },
    { label: "8C", value: "8C" },
    { label: "5X", value: "5X" },
    { label: "PC", value: "PC" },
    { label: "KK", value: "KK" },
    { label: "WF", value: "WF" },
    { label: "G6", value: "G6" },
    { label: "5R", value: "5R" },
];

export const airports =
    [
        {
            "value": "",
            "label": "All"
        },
        {
            "value": "DUB",
            "label": "Dublin Airport"
        },
        {
            "value": "ORK",
            "label": "Cork Airport"
        },
        {
            "value": "BFS",
            "label": "Belfast International Airport"
        },
        {
            "value": "EDI",
            "label": "Edinburgh Airport"
        },
        {
            "value": "BRS",
            "label": "Bristol Airport"
        },
        {
            "value": "ALC",
            "label": "Alicante Airport"
        },
        {
            "value": "RMU",
            "label": "Corvera Airport Murcia (RMU)"
        },
        {
            "value": "GLA",
            "label": "Glasgow Airport"
        },
        {
            "value": "SNN",
            "label": "Shannon Airport"
        },
        {
            "value": "SOU",
            "label": "Southampton Airport"
        },
        {
            "value": "JED",
            "label": "King Abdulaziz International Airport "
        },
        {
            "value": "RUH",
            "label": "King Khalid International Airport"
        },
        {
            "value": "CFN",
            "label": "Donegal Airport"
        },
        {
            "value": "MAN",
            "label": "Manchester Airport"
        },
        {
            "value": "BOS",
            "label": "Boston Airport"
        },
        {
            "value": "SYD",
            "label": "Sydney Airport"
        },
        {
            "value": "PER",
            "label": "Perth Airport"
        },
        {
            "value": "LHR",
            "label": "London Heathrow"
        },
        {
            "value": "BHX",
            "label": "Birmingham Airport"
        },
        {
            "value": "JER",
            "label": "Jersey Airport"
        },
        {
            "value": "BHD",
            "label": "Belfast City Airport"
        },
        {
            "value": "INV",
            "label": "Inverness Airport"
        },
        {
            "value": "AUH",
            "label": "Zayed International Airport"
        },
        {
            "value": "DOH",
            "label": "Hamad International Airport"
        },
        {
            "value": "MLA",
            "label": "Malta International Airport"
        }
    ];

export const reportsWithTotalCountHeader = ["passengersRecord", "arrivalBookings", "departuresBookings", "employeeConversations"]
export const reportsWithAirlineFilter = ["AirlinePerformanceReport", "departuresBookings", "arrivalBookings", "passengersRecord"]

export const productivityReportTitles = [
    "Employee Name",
    "Employee Role",
    "Number of Sessions",
    "Total Passengers Assigned",
    "Total Passengers Started",
    "Total Flights Assigned",
    "Total Flights Started",
    "Productivity (Passengers)",
    "Productivity (Flights)",
];

export const productivityReportKeys = [
    "employeeName",
    "employeeRole",
    "sessions",
    "passengersAssigned",
    "passengersStarted",
    "flightsAssigned",
    "flightsStarted",
    "productivityPassengers",
    "productivityFlights",
];

export const appSessionLogTitles = [
    "Employee Name",
    "Employee Role",
    "Email",
    "Date",
    "Log in Time",
    "Log Out Time",
    "Time Active",
];

export const appSessionLogKeys = [
    "employeeName",
    "employeeRole",
    "email",
    "date",
    "logInTime",
    "logOutTime",
    "timeActive",
];

export const shiftsReportTitles = [
    "Employee Name",
    "Employee Role",
    "Date",
    "Shift Start",
    "Shift End",
    "Time Active",
];

export const shiftsReportKeys = [
    "employeeName",
    "employeeRole",
    "date",
    "shiftStart",
    "shiftEnd",
    "timeActive",
];

export const breaksReportTitles = [
    "Date",
    "Employee Name",
    "Employee Role",
    "Break Start Time",
    "Break Finish Time",
];

export const breaksReportKeys = [
    "date",
    "employeeName",
    "employeeRole",
    "breakStartTime",
    "breakEndTime",
];

export const gateChangesReportTitles = [
    "Date",
    "Flight Number",
    "Gate Change From",
    "Gate Change To",
    "Time of Change",
    "PRM Pax Affected",
];

export const gateChangesReportKeys = [
    "date",
    "flightNumber",
    "originalGate",
    "currentGate",
    "changeTime",
    "paxAffected",
];

export const deviceReportTitles = [
    "Device Alias",
    "Device ID",
    "Model",
    "Last Known Employee",
    "Last Login Time",
];

export const deviceReportKeys = [
    "deviceAlias",
    "deviceId",
    "model",
    "lastKnownEmployee",
    "lastLoginTime",
];

export const vehicleReportTitles = [
    "Date",
    "Vehicle Alias",
    "Employee Name",
    "Last Active"
];

export const vehicleReportKeys = [
    "date",
    "vehicleAlias",
    "employeeName",
    "lastActive"
];

export const thirdStateFlightsReportTitles = [
    "Flight Number",
    "Origin Airport",
    "Flight Date",
    "Gate",
    "Stand",
    "Terminal",
    "Check-in Zone",
    "Aircraft Type",
    "Time",
    "Ambilift Type",
    "Operating Status",
    "Passenger Count",
    "Seat Capacity",
    "Flight Key",
    "Airbridge Used",
];

export const thirdStateFlightsReportKeys = [
    "flightNumber",
    "departureAirport",
    "flightDate",
    "gate",
    "stand",
    "terminal",
    "checkinZone",
    "aircraftType",
    "operationInfoTime",
    "ambiliftType",
    "operatingStatus",
    "passengerCount",
    "seatCapacity",
    "flightKey",
    "isAirbridgeUsed",
];

export const sunflowerReportTitles = [
    "Date Sold",
    "Airport",
    "Type",
    "Quantity",
    "Amount (€)",
    "Passenger",
    "Email",
    "Reference",
    "Flight",
    "Departure Date",
    "Status",
    "Transaction ID",
];

export const sunflowerReportKeys = [
    "dateSold",
    "airport",
    "type",
    "quantity",
    "revenue",
    "name",
    "email",
    "referenceNumber",
    "flight",
    "departureDate",
    "status",
    "transactionId",
];

export const REPORTS_WITHOUT_LIMITED_DATE_RANGE = ["sunflowerLanyard", "reviews"]